import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Pagination/sgds-pagination";
import { register } from "../../utils/ce-registry";

register("sgds-pagination", Component);

export default createComponent({
  react: React,
  tagName: "sgds-pagination",
  elementClass: Component,
  events: {
    onSgdsPageChange: "sgds-page-change"
  }
});
